import { defineMessages } from 'react-intl'

const scope = 'app.components.SettingsModal'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Settings',
  },
  selectedZone: {
    id: `${scope}.labels.selectedZone`,
    defaultMessage: 'Current Zone',
  },
  close: {
    id: `${scope}.actions.close`,
    defaultMessage: 'Close',
  },
})
